// @flow

import React, { Component } from 'react';
import ScrollMonitor from 'react-scrollmonitor';

type Props = {
  enterViewport: Function,
  children?: React$Node
};

type State = {|
  isTracked?: boolean
|};

export default class TrackScollToOnce extends Component<Props, State> {
  state = {
    isTracked: false
  };

  enterViewport = () => {
    if (!this.state.isTracked) {
      this.props.enterViewport();

      this.setState({
        isTracked: true
      });
    }
  };

  render() {
    return (
      <ScrollMonitor enterViewport={this.enterViewport}>
        <div>{this.props.children}</div>
      </ScrollMonitor>
    );
  }
}
